var map = {
	"./deniedAccess.svg": 1047,
	"./favicon.jpg": 530,
	"./logo-RocRoi.png": 494,
	"./logo.svg": 1048,
	"./logoBono.png": 1049,
	"./logoWhite.svg": 1050,
	"./logo_dsk.svg": 1051,
	"./notFound.png": 1052,
	"./rocroi-logo.png": 541,
	"./user.png": 531
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 112;